module.exports = __webpack_public_path__ + "static/img/yj.c37cb142.png";